import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import useRequest from "../../../components/hooks/use-request";
import { I_Customer, I_Profile } from "../types";
import Navbar from "../../../components/layout/navbar";
import Icon from "../../../assets/icons";
import Tab from "../../../components/tab";
import ActionModal from "./action-modal";
import { showToast } from "../../../components/toast";
import { RingLoader } from "react-spinners";
import AddCustomerDialog from "../../../components/customers/add-customer-dialog";
import OrderHistory from "./order-history";
import Payments from "./payments";
import Button from "../../../components/button";
import { Mail, Phone, Plus,MapPin, ShieldCheck } from "lucide-react";
import AddOrderDialog from "../../../components/orders";
interface OrderData {
  
  _id: string;
    orderId: string;
    source: string;
    totalAmount: number;
    createdAt: string;
    status: string;
    paymentStatus: string;
}
interface PaymentData {
    _id:string;
}
const CustomerDetails = () => {
  const [customer, setCustomer] = useState<I_Customer>();

  const { id } = useParams<{ id: string }>();
  const customerId = id;
  const navigate = useNavigate()
  const [customerType, setCustomerType] = useState("Order History");
  const [orderHistory, setOrderHistory] = useState<OrderData[]>([]);
  const [ordersModal, setOrdersModal] = useState(false);
  const [payments, setPayments] = useState<PaymentData[]>([]);
  console.log(payments)
  const [modalConfig, setModalConfig] = useState<{
    isVisible: boolean;
    actionType: "approve" | "delete" | "decline" | "deactivate";
  }>({
    isVisible: false,
    actionType: "approve",
  });

  const [profile, setProfile] = useState<I_Profile | null>(null);
  const userToken = localStorage.getItem("token");
  const [customerModal, setCustomerModal] = useState(false);
  const { makeRequest: getProfile } = useRequest("/users/profile", "GET", {
    Authorization: `Bearer ${userToken}`,
  });
  const  { makeRequest: getOrders } = useRequest(`/customers/${customerId}/orders`, "GET", {
    Authorization: `Bearer ${userToken}`,
  })
  
  const  { makeRequest: getPayments } = useRequest(`/payment/user/${customerId}`, "GET", {
    Authorization: `Bearer ${userToken}`,
  })
  const { makeRequest: getCustomersById } = useRequest(
    `/customers/${customerId}`,
    "GET"
  );

  const { makeRequest: deleteCustomer } = useRequest(
    `/customers/${customerId}`,
    "DELETE"
  );

  const { makeRequest: approveCustomer, loading } = useRequest(
    `/customers/${customerId}/approve`,
    "POST",
    {
      Authorization: `Bearer ${userToken}`,
    }
  );
  const { makeRequest: declineCustomer } = useRequest(
    `/customers/${customerId}/reject`,
    "POST",
    {
      Authorization: `Bearer ${userToken}`,
    }
  );

  useEffect(() => {
    const fetchData = async () => {
      const [response] = await getCustomersById();
      setCustomer(response?.data?.customer || []);
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const [response] = await getOrders();
  
      setOrderHistory(response?.data || []);
    };

    fetchData()
  }, [])
  useEffect(() => {
    const fetchData = async () => {
      const [response] = await getPayments();
      setPayments(response?.data || []);
    };

    fetchData()
  }, [])

  useEffect(() => {
    const fetchProfile = async () => {
      const [response] = await getProfile();
      if (response.status) {
        setProfile(response.data?.user);
      }
    };
    fetchProfile();
  }, []);

  const handleConfirmAction = async () => {
    if (modalConfig.actionType === "approve") {
      const [response] = await approveCustomer();
      if (response?.status) {
        showToast(response.message, true);
        window.location.reload()
      } else {
        showToast(response?.message, false);
      }
    } else if (modalConfig.actionType === "delete") {
      const [response] = await deleteCustomer();
      if (response?.status) {
        showToast(response.message, true);
        navigate(-1)
      } else {
        showToast(response?.message, false);
      }
    } else if (modalConfig.actionType === "decline") {
      const [response] = await declineCustomer();
      if (response?.status) {
        showToast(response.message, true);
         window.location.reload()
      } else {
        showToast(response?.message, false);
      }
    }
  };

  const handleApprove = () => {
    setModalConfig({
      isVisible: true,
      actionType: "approve",
    });
  };

  const handleDelete = () => {
    setModalConfig({
      isVisible: true,
      actionType: "delete",
    });
  };
  const handleDeactivate = () => {
    setModalConfig({
      isVisible: true,
      actionType: "deactivate",
    });
  };
  const handleDecline = () => {
    setModalConfig({
      isVisible: true,
      actionType: "decline",
    });
  };

  function closeCustomerModal() {
    setCustomerModal(false);
  }

  function openCustomerModal() {
    setCustomerModal(true);
  }

   function closeOrderModal() {
        setOrdersModal(false);
    }

    function openOrderModal() {
        setOrdersModal(true);
    }

    console.log(customer, "customer details page");

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      {profile && <Navbar profile={profile} />}

      <main className="flex-1 container mx-auto py-6">
        <div className="flex justify-between gap-5 mt-5 mx-10">
          <div className="flex gap-4">
            <div
              onClick={() => navigate(-1)}
              className="flex gap-2 font-semibold text-[16px] border-r-2 pr-4 border-separate cursor-pointer "
            >
              <Icon name="appbackIcon" className="mt-1" /> Back to Customers
            </div>

            <h1 className="md:text-[30px] -mt-2 font-bold">
              {customer?.contactName}
            </h1>
          </div>

          <div className="text-[14px] flex gap-2">
            <button
              type="button"
              className="font-normal flex border gap-1 rounded-full p-2"
              onClick={openCustomerModal}
            >
              <Icon name="editIconBlack" /> Edit
            </button>

            

            {customer?.approvalStatus === "rejected" && (

              <div className="flex gap-5">
              
                  <button
                    type="button"
                    className="font-normal flex bg-[#FFF1F2] text-[#E11D48] border border-[#FDA4AF]  gap-1 rounded-full p-2"
                    onClick={handleDelete}
                  >
                    <Icon name="markIcon" /> Delete Customer
                  </button>
                  

                </div>

               
           
              
            )}
            {customer?.approvalStatus === "approved" && (

              <div className="flex gap-5 justify-between">
              
                  <Button
                    size="lg"
                    variant="tertiary"
                    // className="font-normal flex bg-[#FFF1F2] text-[#E11D48] border border-[#FDA4AF]  gap-1 rounded-full p-2"
                    onClick={handleDelete}
                  >
                    <Icon name="markIcon" /> Delete Customer
                  </Button>
                  <Button
                    size="lg"
                    variant="primary"
                    type="button"
                    className="font-normal md:mt-0 mt-6"
                    // onClick={openOrderModal}
                  >
                    
                    <Plus />
                    Create Sales Order
                  </Button>

                </div>

               
           
              
            )}
            {customer?.approvalStatus === "pending" && (
              <div className="flex gap-3">
                <button
                  type="button"
                  className="font-normal flex bg-[#FFF1F2] text-[#E11D48] border border-[#FDA4AF] gap-1 rounded-full p-2"
                  onClick={handleDecline}
                >
                  <Icon name="markIcon" /> Decline
                </button>

                <button
                  type="button"
                  className="font-normal flex bg-[#047401] text-[#fff] border gap-1 rounded-full p-2"
                  onClick={handleApprove}
                >
                  <Icon name="cancelIcon" /> Approve
                </button>
              </div>
              
            )}
          </div>
        </div>



        <div className="grid grid-cols-3 gap-6 mt-5 mx-10 mb-20">
          <div className="col-span-2">
            <div className="flex flex-col justify-center items-center mx-10">
              <Tab
                activeTab={customerType}
                tabs={["Order History", "Payments"]}
                setActiveTab={setCustomerType}
              />
            </div>

            {customerType === "Order History" && <OrderHistory data={orderHistory} customers={customer}/>}
            {customerType === "Payments" && <Payments data={payments}/>}
          </div>
          
          <div className="col-span-1 bg-white shadow-lg rounded-lg p-6">
           <h2 className="text-lg font-semibold mb-4 px-6 py-3">
              Customer Details
            </h2>

            <div className="border-t pt-4 p-6 mt-5">
              <div className="flex flex-col gap-4">
                <div className="flex gap-4 items-center">
                    <div className="bg-[#E8F2E8] rounded-full p-3">
                        <Icon name="users" />
                    </div>
                    <div>
                        <p className="text-gray-500 text-sm mb-1">Customer Id</p>
                        <p className="font-medium capitalize">{customer?.customerId}</p>
                    </div>
                </div>
                <div className="flex gap-4 items-center">
                    <div className="bg-[#E8F2E8] rounded-full p-3">
                        <Icon name="users" />
                    </div>
                    <div>
                        <p className="text-gray-500 text-sm mb-1">Business Name</p>
                        <p className="font-medium capitalize">{customer?.businessName || "Nill"}</p>
                    </div>
                </div>
                <div className="flex gap-4 items-center">
                    <div className="bg-[#E8F2E8] rounded-full p-3">
                        <Icon name="users" />
                    </div>
                    <div>
                        <p className="text-gray-500 text-sm mb-1">Business Type</p>
                        <p className="font-medium capitalize">{customer?.businessType || "Nill"}</p>
                    </div>
                </div>
                <div className="flex gap-4 items-center">
                    <div className="bg-[#E8F2E8] rounded-full p-3">
                        <Icon name="users" />
                    </div>
                    <div>
                        <p className="text-gray-500 text-sm mb-1">Account Type</p>
                        <p className="font-medium capitalize">{customer?.accountType}</p>
                    </div>
                </div>
                <div className="flex gap-4 items-center">
                    <div className="bg-[#E8F2E8] rounded-full p-3">
                        <Icon name="users" />
                    </div>
                    <div>
                        <p className="text-gray-500 text-sm mb-1">Full Name</p>
                        <p className="font-medium capitalize">{customer?.contactName}</p>
                    </div>
                </div>
                <div className="flex gap-4 items-center">
                    <div className="bg-[#E8F2E8] rounded-full p-3">
                        <Phone color="#047401"/>
                    </div>
                    <div>
                        <p className="text-gray-500 text-sm mb-1">Phone Number</p>
                        <p className="font-medium capitalize">{customer?.contactNumber}</p>
                    </div>
                </div>
                <div className="flex gap-4 items-center">
                    <div className="bg-[#E8F2E8] rounded-full p-3">
                        <Mail color="#047401"/>
                    </div>
                    <div>
                        <p className="text-gray-500 text-sm mb-1">Email Address</p>
                        <p className="font-medium capitalize">{customer?.email}</p>
                    </div>
                </div>
                <div className="flex gap-4 items-center">
                    <div className="bg-[#E8F2E8] rounded-full p-3">
                        <MapPin color="#047401"/>
                    </div>
                    <div>
                        <p className="text-gray-500 text-sm mb-1">Address</p>
                        <p className="font-medium capitalize">{customer?.address?.street}</p>
                    </div>
                </div>
                <div className="flex gap-4 items-center">
                    <div className="bg-[#E8F2E8] rounded-full p-3">
                        <ShieldCheck color="#047401"/>
                    </div>
                    <div>
                        <p className="text-gray-500 text-sm mb-1">Status</p>
                        <p className="font-medium capitalize">{customer?.approvalStatus}</p>
                    </div>
                </div>

              </div>

            </div>

          </div>
          
        </div>

        {loading ? (
          <RingLoader color="#ffffff" loading={loading} size={20} />
        ) : (
         <ActionModal
            visible={modalConfig.isVisible}
            onCancel={() => setModalConfig({ ...modalConfig, isVisible: false })}
            onConfirm={handleConfirmAction}
            title={`Customer ${
              modalConfig.actionType === "approve" 
                ? "Approval" 
                : modalConfig.actionType === "delete"
                ? "Delete"
                : modalConfig.actionType === "decline"
                ? "Decline" 
                : modalConfig.actionType === "deactivate"
                ? "Deactivation"
                : "Action" // Added default case
            }`}
            content={`Are you sure you want to ${modalConfig.actionType} customer "${customer?.contactName}"?`}
            actionType={modalConfig.actionType}
          />
        )}
      </main>
      

      <AddCustomerDialog 
       isVisible={customerModal}
       onClose={closeCustomerModal}
       customer={customer}
      />
      <AddOrderDialog
        isVisible={ordersModal}
        onClose={closeOrderModal}
        // customers={customer}
        // product={product}
      />
    </div>
  );
};

export default CustomerDetails;
